import { SortingState } from '@tanstack/react-table';

import { create } from '~/utils/store/createStore';

import { getDefaultInsightsFilterState, InsightsAnalysisType } from './utils';

export type InsightsFilterState = Record<
  string,
  { key: InsightsAnalysisType; checked: boolean }[]
>;

type AssetsTableStore = {
  sortingState: SortingState;
  insightsFilterState: InsightsFilterState;
  reset: () => void;
};

export const useAssetsTableStore = create<AssetsTableStore>(set => {
  const initialState = {
    sortingState: [],
    insightsFilterState: getDefaultInsightsFilterState(true),
  };
  return {
    ...initialState,
    reset: () => {
      set(initialState);
    },
  };
});
